// iconData.ts
// 图标数据加载模块 — 使用 import() 替代 fetch()
// 统一使用 Solar 图标集

interface IconData {
  prefix: string
  icons: Record<string, { body: string }>
}

let solarData: IconData | null = null
let loadingPromise: Promise<IconData> | null = null

/**
 * 加载 Solar 图标数据（异步，自动缓存）
 */
async function loadSolarBundle(): Promise<IconData> {
  if (solarData) return solarData
  if (loadingPromise) return loadingPromise

  loadingPromise = import('@/assets/icons/solar.json')
    .then((m) => {
      solarData = m.default
      loadingPromise = null
      return solarData
    })
    .catch((err) => {
      console.error('[iconData] 加载 Solar 图标失败:', err)
      loadingPromise = null
      return { prefix: 'solar', icons: {} }
    })

  return loadingPromise
}

/**
 * 解析 icon 字符串为 { prefix, name }
 *   "solar:close-circle"     → { prefix: "solar", name: "close-circle" }
 *   "vi-solar:settings"      → { prefix: "solar", name: "settings" }
 */
export function parseIconName(icon: string): { prefix: string; name: string } {
  const colonIdx = icon.indexOf(':')
  if (colonIdx === -1) return { prefix: '', name: icon }

  const prefix = icon.slice(0, colonIdx)
  const name = icon.slice(colonIdx + 1)

  // 统一规范化为 "solar"
  if (prefix === 'vi-solar') {
    return { prefix: 'solar', name }
  }

  return { prefix: name ? prefix : 'solar', name: name || prefix }
}

/**
 * 获取图标 SVG body（异步，首次使用时触发 chunk 加载）
 * @returns SVG body 字符串，或空字符串
 */
export async function getIconBody(_prefix: string, name: string): Promise<string> {
  const bundle = await loadSolarBundle()
  return bundle.icons[name]?.body || ''
}
